import { ActionType } from '../actionTypes';
import { Action } from '../actions/flyerDetailsActions';

import { Dispatch } from 'redux';

import { FlyerDetailsState } from '../reducers/flyerDetailsReducer';
import {ImageDataForPage} from "../../dtos";


export const updateFlyerDetailsState = (newState: FlyerDetailsState) => {

    return async (dispatch: Dispatch<Action>) => {
        dispatch({ 
            type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
            payload: newState
        });
    }

}

export const updateFlyerDetailsPageImageState = (data: ImageDataForPage) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.FLYER_DETAILS_SET_IMAGE_TO_TARGET_PAGE,
            payload: data
        });
    }

}